import React, { Component } from 'react'
import { Provider } from 'react-redux'
import { Router, Route, Switch } from 'react-router-dom'
import { create as createJss } from 'jss'
import { JssProvider, ThemeProvider } from 'react-jss'
import { StripeProvider, Elements } from 'react-stripe-elements'
import { ToastContainer } from 'react-toastify'
import { hot } from 'react-hot-loader/root'
import jssPluginCamelCase from 'jss-plugin-camel-case'
import jssPluginTemplate from 'jss-plugin-template'
import jssPluginNested from 'jss-plugin-nested'
import jssPluginGlobal from 'jss-plugin-global'
import * as Sentry from '@sentry/browser'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faCaretDown } from '@fortawesome/free-solid-svg-icons'
import { createBrowserHistory } from 'history'
import { STRIPE_API_KEY } from './config'
import store from './store'
import MainWrapper from './components/MainWrapper'
import MainRouter from './components/MainRouter'
import ErrorBoundary from './components/ErrorBoundary'
import RouteTransitionWrapper from './components/RouteTransitionWrapper'
import 'react-toastify/dist/ReactToastify.css'
import { ClientEventHandler } from './utils/clientEventHandler'

const jss = createJss()
jss.use(jssPluginCamelCase(), jssPluginTemplate(), jssPluginNested(), jssPluginGlobal())

library.add(faCaretDown)

const theme = {}
const history = createBrowserHistory()

class App extends Component {
  state = {
    stripe: null,
  }

  componentDidMount() {
    if (window.Stripe) {
      this.setState({ stripe: window.Stripe(STRIPE_API_KEY) })
    } else {
      document.querySelector('#stripe-js').addEventListener('load', () => {
        this.setState({ stripe: window.Stripe(STRIPE_API_KEY) })
      })
    }
    if (!window.clientEventHandler) {
      window.clientEventHandler = ClientEventHandler.instance
    }
    if (process.env.NODE_ENV === 'production') {
      Sentry.init({
        dsn: 'https://324b6d6a644f4eb38c9513e17a3dc1bc@sentry.io/1505622',
      })
    }
    window.setupWebViewJavascriptBridge = (callback) => {
      if (window.WebViewJavascriptBridge) {
        return callback(window.WebViewJavascriptBridge)
      }
      if (window.WVJBCallbacks) {
        return window.WVJBCallbacks.push(callback)
      }
      window.WVJBCallbacks = [callback]
      const WVJBIframe = document.createElement('iframe')
      WVJBIframe.style.display = 'none'
      WVJBIframe.src = 'https://__bridge_loaded__'
      document.documentElement.appendChild(WVJBIframe)
      setTimeout(() => {
        document.documentElement.removeChild(WVJBIframe)
      }, 0)
    }
    window.setupWKWebViewJavascriptBridge = (callback) => {
      if (window.WKWebViewJavascriptBridge) {
        return callback(window.WKWebViewJavascriptBridge)
      }
      if (window.WKWVJBCallbacks) {
        return window.WKWVJBCallbacks.push(callback)
      }
      window.WKWVJBCallbacks = [callback]
      if (window.webkit && window.webkit.messageHandlers && window.webkit.iOS_Native_InjectJavascript && window.webkit.iOS_Native_InjectJavascript.postMessage) {
        window.webkit.messageHandlers.iOS_Native_InjectJavascript.postMessage(null)
      }
    }
    window.setupWebViewJavascriptBridge((bridge) => {
      console.log('bridge', bridge)
      bridge.registerHandler('postMessage', (data, callback) => {
        console.log('postMessage', data)
        const { type, payload } = data
        ClientEventHandler.instance.emit(type, payload)
      })
    })
    window.setupWKWebViewJavascriptBridge((bridge) => {
      console.log('bridge', bridge)
      bridge.registerHandler('postMessage', (data, callback) => {
        console.log('postMessage', data)
        const { type, payload } = data
        ClientEventHandler.instance.emit(type, payload)
      })
    })
  }

  render() {
    const { stripe } = this.state
    return (
      <ErrorBoundary>
        <JssProvider jss={jss}>
          <ThemeProvider theme={theme}>
            <Provider store={store}>
              <ToastContainer />
              <StripeProvider stripe={stripe}>
                <Elements>
                  <Router history={history}>
                    <RouteTransitionWrapper>
                      <Switch>
                        <Route path="/school/:schoolCode">
                          <MainWrapper>
                            <MainRouter />
                          </MainWrapper>
                        </Route>
                      </Switch>
                    </RouteTransitionWrapper>
                  </Router>
                </Elements>
              </StripeProvider>
            </Provider>
          </ThemeProvider>
        </JssProvider>
      </ErrorBoundary>
    )
  }
}

export default hot(App)
